import React, { Component } from 'react';
import { Row, Col } from '../../components/GridSystem';

const people = [
	{
		name: 'Andini',
		title: 'CEO & UX Designer',
		image: require('../../assets/people/andini-staff-web-hubton.png'),
	},
	{
		name: 'Zaki',
		title: 'CCO & UI Designer',
		image: require('../../assets/people/zaki-staff-web-hubton.png'),
	},
	{
		name: 'Arif',
		title: 'Lead Developer',
		image: require('../../assets/people/arif-staff-web-hubton.png'),
	},
	{
		name: 'Rahmat',
		title: 'Web Developer',
		image: require('../../assets/people/rahmat-staff-web-hubton.png'),
	},
	{
		name: 'Satria',
		title: 'Senior Graphic Designer',
		image: require('../../assets/people/satria-staff-web-hubton.png'),
	},
	{
		name: 'Bambang',
		title: 'Graphic Designer',
		image: require('../../assets/people/bambang-staff-web-hubton.png'),
	},
	{
		name: 'Poppy',
		title: 'Junior Graphic Designer',
		image: require('../../assets/people/poppy-staff-web-hubton.png'),
	},
	{
		name: 'Dodi',
		title: 'General Affair',
		image: require('../../assets/people/dodi-staff-web-hubton.png'),
	},
	{
		name: 'Andita',
		title: 'Online Content Officer',
		image: require('../../assets/people/andita-staff-web-hubton.png'),
	},
	{
		name: 'Deri',
		title: 'Office Assistant',
		image: require('../../assets/people/deri-staff-web-hubton.png'),
	},
];

class PeopleBlock extends Component {
	renderPeopleList() {
		return people.map((person, index) => {
			return (
				<Col xs={6} md={4} lg={3} className="team-item" key={index}>
					<div className="team-item__image">
						<img src={person.image} alt={person.name} />
					</div>
					<h3 className="team-item__name">{person.name}</h3>
					<div className="team-item__position">{person.title}</div>
				</Col>
			);
		});
	}

	render() {
		return (
			<div className="block-item block-item--team clearfix">
				<h2 className="block-item__title large--three-twelfths">People</h2>

				<div className="block-item__inner large--nine-twelfths">
					<div className="block-item__content">
						<p>A family of experienced Thinkers, Designers, Developers with national and international educational background. We love natural adventure, drawing, playing musical instruments, games, biking, surfing and cuddling with our kids. Oh and we love a good laugh too.</p>
					</div>
					<div className="block-item__footer">
						<Row className="team-list grid-uniform">
							{ this.renderPeopleList() }
						</Row>
					</div>
				</div>
			</div>
		);
	}
};

export default PeopleBlock;



// WEBPACK FOOTER //
// ./src/containers/About/PeopleBlock.js